// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  Auth,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const testFirebaseConfig = {
  apiKey: "AIzaSyDUMMY000000000000000000000000000000",
  authDomain: "viewr-test.firebaseapp.com",
  projectId: "viewr-test",
  storageBucket: "viewr-test.appspot.com",
  messagingSenderId: "000000000000",
  appId: "1:000000000000:web:0000000000000000000000",
  measurementId: "G-0000000000",
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId,
};

const resolvedFirebaseConfig =
  process.env.NODE_ENV === "test"
    ? {
        ...testFirebaseConfig,
        ...Object.fromEntries(
          Object.entries(firebaseConfig).filter(([, value]) => Boolean(value)),
        ),
      }
    : firebaseConfig;

// Initialize Firebase
const app: FirebaseApp = initializeApp(resolvedFirebaseConfig);
//const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth: Auth = getAuth(app);
export const googleProvider: GoogleAuthProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});
googleProvider.addScope("email");
googleProvider.addScope("profile");
export const appleProvider: OAuthProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");

// Microsoft OAuth Provider 설정
export const microsoftProvider: OAuthProvider = new OAuthProvider(
  "microsoft.com"
);
microsoftProvider.setCustomParameters({
  prompt: "select_account",
});
microsoftProvider.addScope("openid");
microsoftProvider.addScope("profile");
microsoftProvider.addScope("email");
